import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { RadioItem } from '@adc/ui-core'

class SubEntityFormHeader extends Component {
  static propTypes = {
    formKey: PropTypes.string.isRequired,
    forms: PropTypes.array.isRequired,
    handleItemClick: PropTypes.func.isRequired,
    onSelectItem: PropTypes.func.isRequired,
    openedFormIndex: PropTypes.number.isRequired,
  }

  render() {
    const { formKey, forms, handleItemClick, onSelectItem, openedFormIndex } =
      this.props

    if (forms.length < 2) {
      return null
    } else {
      return forms.map((form, index) => (
        <RadioItem
          name={`${formKey}.title`}
          checked={openedFormIndex === index}
          label={form.label}
          elmId={`${formKey}.${_.snakeCase(form.formType)}_form`}
          key={index}
          onClick={() => onSelectItem(handleItemClick, index, form.formType)}
        />
      ))
    }
  }
}

export default SubEntityFormHeader
